import { Paycode, PaycodeAssignEmployeeItem, PaycodeAssignEmployees, PaycodeAssignEmployee, PaycodeCreate } from 'repository/timekeeper/@types/PaycodeModel';

export class PaycodeRepository {
    private httpService: IHttpService
    constructor(instance: IHttpService) {
        this.httpService = instance;
    }
    async getPaycodes(
        type?: "paycode" | "paycode_combination" | "overtime" | "paycode_distribution" | "exception_rule" | "bonus_rule" | "credit_holiday_rule" | "standard" | "domino" | "duration"
    ): Promise<Paycode[]> {
        try {
            const response = await this.httpService.get<TKResponse<Paycode[]>>('/paycodes', {
                params: {
                    t: type
                }
            });
            const data = response.data.map((paycode: Paycode) => {
                return {
                    ...paycode,
                    id: paycode.paycode_id
                };
            });
            return data.sort((a, b) => ((a as any).name ?? '').localeCompare((b as any).name ?? ''));
        } catch (error) {
            console.error('Error al obtener los paycodes:', error);
            throw error;
        }
    }
    async getById(paycodeId: number): Promise<Paycode> {
        try {
            const response = await this.httpService.get<TKResponse<Paycode>>(`/paycodes/${paycodeId}`);
            return {
                ...response.data,
                id: response.data.paycode_id
            };
        } catch (error) {
            console.error('Error al obtener el paycode por ID:', error);
            throw error;
        }
    }
    async create(data: PaycodeCreate): Promise<Paycode> {
        try {
            const response = await this.httpService.post<TKResponse<Paycode>, PaycodeCreate>('/paycodes', { data });
            return response.data
        } catch (error) {
            console.error('Error al crear el paycode:', error);
            throw error;
        }
    }
    async update(paycodeId: number, data: PaycodeCreate): Promise<Paycode> {
        try {
            const response = await this.httpService.patch<TKResponse<Paycode>, PaycodeCreate>(`/paycodes/${paycodeId}`, { data });
            return response.data;
        } catch (error) {
            console.error('Error al actualizar el paycode:', error);
            throw error;
        }
    }
    async delete(paycodeId: number): Promise<void> {
        try {
            await this.httpService.delete(`/paycodes/${paycodeId}`);
        } catch (error) {
            console.error('Error al eliminar el paycode:', error);
            throw error;
        }
    }

    async getPaycodeAssignEmployee(params?: URLSearchParams): Promise<PaycodeAssignEmployee[]> {
        try {
            const query: Record<string, any> = {};
            if (params) {
                params.forEach((value, key) => {
                    query[key] = value;
                });
            }
            const response = await this.httpService.get<TKResponse<PaycodeAssignEmployee[]>>('/paycode_assign', { params: query });
            return response.data;
        } catch (error) {
            console.error("Axios Error:", error);
            throw error;
        }
    }

    async savePaycodeAssignEmployees(paycodes: PaycodeAssignEmployees) {
        try {
            const data = await this.httpService.post(`/paycode_assign`, { data: paycodes });
            console.log(data);
            return data;
        } catch (error) {
            console.error("Axios Error:", error);
            throw error;
        }
    }
    async updatePaycodeAssignEmployee(paycode_id: number, paycode: PaycodeAssignEmployeeItem) {
        try {
            const data = await this.httpService.patch(`/paycode_assign/${paycode_id}`, { data: paycode });
            console.log(data);
            return data;
        } catch (error) {
            console.error("Axios Error:", error);
            throw error;
        }
    }
    async deletePaycodeAssignEmployees(paycode:number) {
        try {
            const data = await this.httpService.delete(`/paycode_assign/${paycode}`);
            console.log(data);
            return data;
        } catch (error) {
            console.error("Axios Error:", error);
            throw error;
        }
    }

}